import ManageProtocole from '@/views/consultations/en-cours/protocole-soins/manage-protocole'
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EnteteA5 from '@/views/entete-a5';
import { cca_config } from '@/config';

import $ from 'jquery'

export default {
    name: 'protocole-soins',
    components: {
        ManageProtocole, EnteteBonEtFacture, EnteteA5
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number
    },
    data() {
        return {
            is_loading: false,
            is_empty: true,
            state_toggler: 0,
            selected_protocole: {},
            selected_cat_consigne: {},
            selected_protocole_hn: [],

            format_ordonnace: 'a5',    
            width_ordonnance: '559px',
            font_size: 'font-12',
            filename: '',
            ordonnance_to_print: {},
            pdl_papier_entete: cca_config.PDL_PAPIER_ENTETE,
            info_patient: {},
            info_caissier: {}
        }
    },

    watch: {
        evolution_toggler() {
            this.getListeProtocoleSoins()
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        consultation_protocoles_soins() {
            return this.$store.getters['consultation_protocoles_soins'];
        },

        patient(){
            return this.$store.getters['patient'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted() {
        this.getListeProtocoleSoins()

        const t = new Date()
        this.filename = 'Ordonnance_'+this.patient.nom+' '+this.patient.prenoms+'_'+t.getTime()

        this.userInfoSetter()
    },

    methods: {
        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code
            }

            this.info_caissier = {
                nom_caissier: this.userCredentials.name,
                titre: this.userCredentials.titre
            }
        },

        addProtocole() {
            this.state_toggler = (this.state_toggler === 0)?1:0
        },

        editProtocole(protocole) {
            console.log(protocole);
        },

        editCatConsigne(protocole, cat, evolution_id) {
            this.selected_cat_consigne = cat
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        addCatConsigne(protocole, evolution_id) {
            this.selected_cat_consigne = {
                cat_id: 0
            }
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        getListeProtocoleSoins() {
            this.is_loading = true

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                est_encours: true
            }
            this.$store.dispatch('getConsultationProtocoleSoins', data).then(() => {
                if (this.consultation_protocoles_soins.length == 0) {
                    this.is_empty = true 
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            })
        },
        
        dropContent(index) {
            var el = document.getElementById('dc'+index)

            // Check if element has class show
            if ($('#dc'+index).hasClass("show")) {
                el.classList.remove('show')
            } else {
                el.classList.add('show')
            }
        },

        printOrdonnance(ordonnance) {
            
            this.ordonnance_to_print = ordonnance
        },

        setCatToDelete(cat, protocole, evolution_id) {
            this.selected_cat_consigne = cat
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        },

        setProtocoleToDelete(protocole, evolution_id) {
            this.selected_protocole = protocole
            this.selected_protocole.evolution_id = evolution_id
        }
    }
}


